/**
 * Utilise the tagging functionality that is available in the CoreWebsite through the DOM.
 */

const printWarning = (name, value, event) => {
  if (process.env.NODE_ENV === 'development') {
    const getJsonObject = event =>
      typeof event === 'object' ? JSON.stringify(event) : event
    console.warn(
      `Tagging: ${name} is ${value} ${
        event ? `, could not tag event ${getJsonObject(event)}` : ''
      }`
    )
  }
}

const dom = {
  previousPageName: '',
  /**
   * @return {Object} [{}] Predefined tagging values that are provided by the back-end.
   */
  getStaticTags: () => {
    const { tmParam } = window
    if (!tmParam) printWarning('tmParam', tmParam)
    return tmParam || {}
  },
  /**
   * Push the tagging information to the designated analytics server.
   * @param {Object} event - Event that describes the tags.
   */
  pushEvent: event => {
    const { _waq } = window
    if (!_waq) {
      printWarning('_waq', _waq, event)
      return
    }
    // when React renders a component multiple times just tag it once
    if (dom.previousPageName === event.eventData.page_name) {
      return
    }
    dom.previousPageName = event.eventData.page_name
    _waq.push(event)
  },
}

/**
 * Push the tagging information for a specific page.
 * @param {Object} tags - Data that needs to be tagged.
 */
export const tagPageview = (tags = {}) => {
  dom.pushEvent({
    eventName: 'DynamicPageview',
    eventData: {
      ...dom.getStaticTags(),
      ...tags,
    },
  })
}
